import { Component, Input } from '@angular/core';
import { CurrencyPipe, NgClass, NgFor, NgForOf, NgIf } from '@angular/common';
import { FloatingPopoverDirective } from '@app/directives/floating-popover.directive';

@Component({
  selector: 'app-city-lodging-item',
  standalone: true,
  imports: [NgClass, NgFor,NgIf, FloatingPopoverDirective],
  templateUrl: './city-lodging-item.component.html',
  styleUrls: ['./city-lodging-item.component.scss']
})
export class CityLodgingItemComponent {

  @Input() cityLabel!: string;           // e.g., "T1", "T2", "T3"
  @Input() cityNames!: string | null;    // e.g., "Mumbai, Delhi"

  getCities(): string[] {
    if (!this.cityNames) return [];
    return this.cityNames
      .split(',')
      .map(city => city.trim())
      .filter(city => city.length > 0);
  }
}